import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1)
const _hoisted_3 = {
  id: "fullName-help",
  class: "p-error"
}
const _hoisted_4 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "username" }, "Username", -1)
const _hoisted_6 = {
  id: "fullName-help",
  class: "p-error"
}
const _hoisted_7 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "handle" }, "Handle", -1)
const _hoisted_9 = {
  id: "fullName-help",
  class: "p-error"
}
const _hoisted_10 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1)
const _hoisted_12 = {
  id: "fullName-help",
  class: "p-error"
}
const _hoisted_13 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "confirmPassword" }, "Confirm Password", -1)
const _hoisted_15 = {
  id: "fullName-help",
  class: "p-error"
}
const _hoisted_16 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "birthDate" }, "Birth Date", -1)
const _hoisted_18 = {
  id: "fullName-help",
  class: "p-error"
}

import { RequestStatus } from '@/models/request.model';
import { useUserStore } from '../stores/UserStore';
import { useApiStatusStore } from '@/stores/ApiStatusStore';
import { useForm, configure } from 'vee-validate';
import { computed } from 'vue';
import * as yup from 'yup';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserRegister',
  setup(__props) {

const userStore = useUserStore();
const apiStatusStore = useApiStatusStore();

const ctaLabel = computed(() => {
  const apiStatus = apiStatusStore.getRequestStatus('register');
  switch (apiStatus){
    case RequestStatus.Pending :
      return 'Registering...'
    case RequestStatus.Rejected :
      return 'Register'
    default:
      return 'Register';
  }     
});

const schema = yup.object().shape({
  email: yup.string().required().email().label('Email Address'),
  username: yup.string().required().min(3).label('Username'),
  handle: yup.string().required().min(3).label('Handle'),
  password: yup.string().required().min(8)
    .matches(/(?=.*[0-9])/, 'Password must contain at least one number')
    .matches(/(?=.*[@#$%^&+=.,!?])/, 'Password must contain at least one special character').label('Password'),
  confirmPassword: yup.string().required()
    .oneOf([yup.ref('password')], 'Passwords must match').label('Confirm Password'),
  birthDate: yup.date().required().label('Birth Date')
});

const { defineField, handleSubmit, errors } = useForm({
  validationSchema: schema,
});

const [email] = defineField('email');
const [username] = defineField('username');
const [handle] = defineField('handle');
const [password] = defineField('password');
const [confirmPassword] = defineField('confirmPassword');
const [birthDate] = defineField('birthDate');

configure({
  validateOnBlur: true,
  validateOnChange: false,
  validateOnInput: false,
  validateOnModelUpdate: false
})

const onSubmit = handleSubmit((values: any) => {
  userStore.registerUser(values);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"])),
    class: "mx-auto"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_unref(InputText), {
        modelValue: _unref(email),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
        id: "email",
        type: "email"
      }, null, 8, ["modelValue"]),
      _createElementVNode("small", _hoisted_3, _toDisplayString(_unref(errors).email), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_unref(InputText), {
        modelValue: _unref(username),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(username) ? (username).value = $event : null)),
        id: "username",
        type: "text"
      }, null, 8, ["modelValue"]),
      _createElementVNode("small", _hoisted_6, _toDisplayString(_unref(errors).username), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(_unref(InputText), {
        modelValue: _unref(handle),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(handle) ? (handle).value = $event : null)),
        id: "handle",
        type: "text"
      }, null, 8, ["modelValue"]),
      _createElementVNode("small", _hoisted_9, _toDisplayString(_unref(errors).handle), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createVNode(_unref(InputText), {
        modelValue: _unref(password),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
        id: "password",
        type: "password"
      }, null, 8, ["modelValue"]),
      _createElementVNode("small", _hoisted_12, _toDisplayString(_unref(errors).password), 1)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createVNode(_unref(InputText), {
        modelValue: _unref(confirmPassword),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(confirmPassword) ? (confirmPassword).value = $event : null)),
        id: "confirmPassword",
        type: "password"
      }, null, 8, ["modelValue"]),
      _createElementVNode("small", _hoisted_15, _toDisplayString(_unref(errors).confirmPassword), 1)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createVNode(_unref(InputText), {
        modelValue: _unref(birthDate),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(birthDate) ? (birthDate).value = $event : null)),
        id: "birthDate",
        type: "date"
      }, null, 8, ["modelValue"]),
      _createElementVNode("small", _hoisted_18, _toDisplayString(_unref(errors).birthDate), 1)
    ]),
    _createVNode(_unref(Button), {
      type: "submit",
      label: ctaLabel.value,
      disabled: _unref(apiStatusStore)?.requestPending('register')
    }, null, 8, ["label", "disabled"])
  ], 32))
}
}

})